/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Prefix product card price with "from" because price varies depending on cookies chosen
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('product-card').forEach(card => {
    const title = card.querySelector('product-card-title');
    if (title && title.textContent.toLowerCase().includes('build')) {
      card.querySelectorAll('span.price .price__number').forEach(el => {
        el.insertAdjacentHTML('beforebegin', '<span class="price__from">From: </span>');
      });
    }
  });
});
